<template>
  <v-app>
    <v-system-bar
      app
      color="primary"
      dark
    >
    {{text.appTitle}}<span v-if="!disUsermenu">|<a href="./manual.pdf" target="_blank" style="color:#FFF">{{text.manualA}}</a></span>
      <v-spacer></v-spacer>
      <v-menu offset-y="true">
        <template v-slot:activator="{on}">
          <span v-on="on" class="hoverPointer"><v-icon>mdi-account</v-icon>{{username}}</span>
        </template>
        <v-list dense>
          <v-list-item :disabled="disUsermenu" @click="logout">{{text.logout}}</v-list-item>
          <v-divider></v-divider>
          <v-list-item :disabled="disUsermenu" @click="chgPassword">{{text.chgPassword}}</v-list-item>
          <v-list-item :disabled="disUsermenu" @click="setTotp">{{text.setTotp}}</v-list-item>
        </v-list>
      </v-menu>
    </v-system-bar>

    <v-main>
      <div v-if="!initialLoading && !apiConFail">
        <div v-if="digConfedAdress" class="text-h3">{{text.messege.regMailMessege}}</div>
        <v-card v-if="ecMessege.flag">{{ecMessege.text}}<br><a :href="ecMessege.url">{{text.redirectLogin}}</a></v-card>
        <v-card v-if="ecReport && !ecMessege.flag">
          <v-card-title>{{text.reportTitle}}<br>:{{reportUser}}</v-card-title>
          <v-form>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="4" v-for="qItem in qList" :key="qItem.title">
                    <v-subheader>{{qItem.title}}<span v-show="qItem.required" class="text-left">*{{text.required}}</span></v-subheader>
                    <v-select :error="qItem._error" :error-messages="qItem._errorMessege" v-model="qItem.value" :label="qItem.title" v-if="qItem.type==='select'" :items="qItem.selectItem"></v-select>
                    <v-text-field :error="qItem._error" :error-messages="qItem._errorMessege" v-model="qItem.value" :label="qItem.title" v-if="qItem.type==='text'"></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions class="d-flex flex-column">
                <v-alert type="error" v-model="requiredChkAlert">{{text.messege.invalidRequiredItem}}</v-alert>
                <v-btn @click="submitReport" :disabled="disBtnReportSubmit">{{text.submit}}</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
        <div v-show="!ecReport">
          <Login ref="refLogin" @parentCall="appCall" v-if="components.login.display"/>
          <Admin ref="refAdmin" @parentCall="appCall" v-if="components.admin.display"/>
          <Main ref="refMain" @parentCall="appCall" v-if="components.main.display"/>
        </div>
      </div>
      <div v-if="initialLoading">
        読み込み中
      </div>
      <div v-if="apiConFail">
        Server connection failed.<br>
        サーバーに接続できません。<br>
      </div>
    </v-main>
    <PassworChg ref="refPassChg" @parentCall="appCall" :userData="userData" />
    <v-snackbar top vertical :color="systemMessegeSnack.color" v-model="systemMessegeSnack.show">
      {{systemMessegeSnack.text}}
    </v-snackbar>
    <v-dialog max-width="600px" overlay-opacity="0.8" :persistent="systemMessege.persistent" v-model="systemMessege.show">
      <v-alert :color="systemMessege.color">
        <span v-html="systemMessege.text"></span>
      </v-alert>
    </v-dialog>
    <v-overlay :value="loading">
      <v-progress-circular indeterminate></v-progress-circular>
      {{text.loading}}
    </v-overlay>
  </v-app>
</template>

<script lang="ts">
  import Vue, { del } from 'vue';
  import Login from './components/login-form.vue';
  import Admin from './components/admin-menu.vue';
  import Main from './components/main-form.vue';
  import PassworChg from './components/password-menu.vue';
  import * as comm from './common';
  import * as type from './types';
  import lang from "./lang";
  import {apiRequest} from "./lib/api";
  import {reConnectParamerter} from "./lib/api/securesession/keyEx";
//  import {apiCall} from "./api";
  const api = new apiRequest({
    "headerPrefix":"ogi",
    "saver":{
      "host":`${(new URL(document.URL)).origin}/ec/_api`,
      "clientAuthPoint":"/api/v1/auth/client",
      "keyExchangePoint":"/api/v1/keyex",
      "ottEndPoint":"/api/v1/ott",
      "cert":{"alg":"ES512","crv":"P-521","ext":true,"key_ops":["verify"],"kty":"EC","x":"AEbA9Pj9HZTrwNS4jPAlm4EE01aLp8RhCkBLLSIorO2DNjk5WHNx8PXjQjolu1ibJL0vRJoLzbOfA0gk-OMfBffe","y":"ARjiRSzBb2MRfOi5s6ao6YeaoqhV_GCka34R1GTbOCAhKVH4Zs0UOxqrOBg_6G327IIM8WGxumh-FLwEOi_Djpcz"},
      "cryptoParamerter":"ECDH_P-521,AES-GCM_256,ECDSA_P-521_SHA521",
    },
    "client":{
            "clientId":"spa",
            "clientSecret":"35LrWklpBY3k1y=i_aErmF7nW2j&$&ILx3FeKa3qHy",
      }
  });
  import {indexDb} from "./lib/indexDbStore";
  const db = new indexDb();

  let text = new lang(0);
  interface vueAdd extends Vue{
    parentCallback:(messege:string)=>void;
  }
  interface passwordChgComponent extends Vue{
    chgPassword:()=>void;
    setTotp:()=>void;
  }
  let componentList = {
    login:{display:true} as type.component,
    admin:{display:false} as type.component,
    main:{display:false} as type.component,
  }

  export default Vue.extend({
    name: 'App',

    components: {
      Login,
      Admin,
      Main,
      PassworChg,
    },

    data: () => ({
      //
      text:text.Text,
      api:null as null|{connection:boolean,apiRequest:null|apiRequest},
      apiConFail:false,
      initialLoading:true,
      components:componentList,
      username:"",
      password:"",
      currentPassword:"",
      newPassword:"",
      totpKey:"",
      otpToken:"",
      totpQrCode:null as null|string|Blob,
      userData:{} as type.userData,
      disEcStartBtn:false,
      digTotpInfo:false,
      disUsermenu:true,
      disBtnReportSubmit:false,
      digTotpSet:false,
      digClearTotp:false,
      digChangePassword:false,
      digConfedAdress:false,
      ecStart:false,
      requiredChkAlert:false,
      eventId:"",
      alertInfo:"",
      reportId:"",
      ecReport:false,
      loading:false,
      passwordScore:{
        value:0,
        color:"red"
      },
      systemMessege:{
        show:false,
        color:"red",
        text:"TEXT",
        timeout:1500,
        persistent:false,
      },
      systemMessegeSnack:{
        show:false,
        color:"red",
        text:"TEXT",
        timeout:1500,
        persistent:false,
      },
      qList:[] as Array<type.reportQuColumn & {_error?:boolean,_errorMessege?:string}>,
      reportUser:"",
      ecMessege:{
        flag:false,
        text:"",
        url:"",
      },
      answerProxy:false,
    }),
    mounted(){
      this.initApiCon();
    },
    methods:{
      reset(){
          //@ts-ignore
          Object.assign(this.$data,this.$options.data());
      },
      async checkPrams(params:URLSearchParams){
        let viewMain = true;
        if(params.has("c")){
          const command = params.get("c");
          switch (command){
            case "mcf":
              //アドレス確認
              if(params.has("q")){
                const cfCode = params.get("q");
                if(cfCode && cfCode.length>0 && cfCode.length<64){
                  await this.checkAdressConf(cfCode);
                  if(this.digConfedAdress){
                    viewMain = false;
                  }
                }
              }
            break;
            case "ecf":
              //安否確認配信確認
            break;
            case "ecc":
              //安否確認配信キャンセル
            break;
            case "ece":
              //安否確認配信実行
            break;
            case "eqc":
              //安否確認回答
              if(params.has("q")){
                this.reportId = params.get("q") as string;
                if(params.has('p') && params.get("p")==="y"){
                  this.answerProxy = true;
                }
                if(this.reportId && this.reportId.length < 128){
                  if(this.api && this.api.connection && this.api.apiRequest){
                    const response = await this.api.apiRequest.request.getEcReport(this.reportId);
                    const reportData = response.data.report[0];
                    if(!reportData){
                      return;
                    }
                    this.ecReport = true;
                    this.reportUser = reportData.userName||"";
                    this.qList = [];
                    viewMain = false;
                    for(const [k,v] of Object.entries(reportData.detail)){
                        this.qList.push({
                          "type":v.type,
                          "title":v.title,
                          "selectItem":v.selectItem?v.selectItem:undefined,
                          "required":v.required,
                          "value":v.value?v.value:null,
                          "_error":false,
                          "_errorMessege":"",
                        });
                      }
                  }
                  /*
                  await apiCall.ecReport(this.reportId,this.answerProxy).then(apiResponse=>{
                    if(apiResponse.statusCode === 200 && apiResponse.data){
                      const qData = apiResponse.data;
                      this.ecReport = true;
                      this.reportUser = qData.user;
                      viewMain = false;
                      this.qList = [];
                      for(const [k,v] of Object.entries(qData.q)){
                        this.qList.push({
                          "type":v.type,
                          "title":v.title,
                          "selectItem":v.selectItem?v.selectItem:undefined,
                          "required":v.required,
                          "value":v.value?v.value:null,
                          "_error":false,
                          "_errorMessege":"",
                        });
                      }
                    }
                  })*/
                }
              }
            break;
          }
        }
      },
      appCall(order:string){
        switch(order){
          case "authScces":
            //ログインOK
            this.digConfedAdress = false;
            this.setUserInfo();
          break;
          case "systemMessege":
            this.systemMessege.color = this.$store.state.systemMessege.color;
            this.systemMessege.text = this.$store.state.systemMessege.text;
            if(this.$store.state.systemMessege.timeout < 0){
              this.systemMessege.persistent = false;
            }else if(this.$store.state.systemMessege.timeout > 0){
              this.systemMessege.persistent = false;
              setTimeout(()=>{this.systemMessege.show = false},this.$store.state.systemMessege.timeout)
            }else{
              this.systemMessege.persistent = false;
              setTimeout(()=>{this.systemMessege.show = false},5000)
            }
            this.systemMessege.show = true;
          break;
          case "systemMessegeSnack":
            this.systemMessegeSnack.color = this.$store.state.systemMessege.color;
            this.systemMessegeSnack.text = this.$store.state.systemMessege.text;
            this.systemMessegeSnack.timeout = this.$store.state.systemMessege.timeout;
            this.systemMessegeSnack.show = true;
          break;
          case "loadingON":
            this.loading = true;
          break;
          case "loadingOFF":
            this.loading = false;
          break;
          case "invalidSession":
            //セッションが無効
            this.sessionClear();
          break;
          case "logout":
            this.logout();
            break;
        }
      },
      async initApiCon(){
        let connect = false;
        const dbSession = await db.session.where("name").equals("sessionId").toArray();
        if(dbSession.length > 0 && typeof dbSession[0].value === "string"){
          //indexedDBにセッション情報が保管されている
          const sessionKey = await db.session.where("name").equals(`session_${dbSession[0].value}`).toArray();
          if(sessionKey.length > 0 && typeof sessionKey[0].value === "string"){
            //セッションIDに対応する再接続情報があるので再接続を試みる
            try{
              const reConnectParam = JSON.parse(sessionKey[0].value) as reConnectParamerter;
              connect = await api.connect({reConnect:reConnectParam});
              await db.session.where("name").startsWith("session").delete();
              if(connect){
                //再接続OK
                const curSession = api.getSessionData();
                if(curSession){
                  await db.session.put({"name":"sessionId","value":curSession.sessionId});
                  await db.session.put({"name":`session_${curSession.sessionId}`,"value":JSON.stringify(curSession.reConnectParamerter)});
                }
              }else{
                connect = await api.connect();
              }
            }catch{
              connect = await api.connect();
            }
          }else{
            db.session.where("name").startsWith("session").delete();
            connect = await api.connect();
          }
        }else{
          connect = await api.connect();
        }
        this.initialLoading = false;
        if(connect){
          this.$store.state.apiSaver.connection = true;
          this.$store.state.apiSaver.apiRequest = null;
          this.$store.state.apiSaver.apiRequest = api;
          this.api = this.$store.state.apiSaver;
          const sessionData = await api.request.session();
          const reConnect = api.getSessionData();
          if(reConnect){
            this.updateSessionDb(reConnect.sessionId,reConnect.reConnectParamerter);
          }
          if(sessionData.statusCode === 200){
            if(sessionData.data.status){
              this.$store.commit("setUser",{
                  "userId":sessionData.data.userData.userid,
                  "userName":sessionData.data.userData.username,
                  "administrator":sessionData.data.userData.administrator,
                  "totp":sessionData.data.userData.otpCode,
                  "lastLogin":null,
                  "tpdata":sessionData.data.userData.tpdata,
                  "flags":sessionData.data.userData.flags,
                  "proxyUserKey":sessionData.data.userData.proxyUserKey,
              });
              this.setUserInfo();
            }
          }else{
            this.$store.commit("clearsession",{});
          }
        }else{
          this.apiConFail = true;
        }
        const params = (new URL(location.href)).searchParams;
        this.checkPrams(params);
      },
      async updateSessionDb(sessionId:string,reConnectionKey:reConnectParamerter){
        await db.session.where("name").equals("sessionId").delete();
        await db.session.where("name").startsWith("sessionId_").delete();
        await db.session.put({"name":"sessionId","value":sessionId});
        await db.session.put({"name":`session_${sessionId}`,"value":JSON.stringify(reConnectionKey)});
      },
      async sessionClear(){
        await db.session.where("name").equals("sessionId").delete();
        await db.session.where("name").startsWith("sessionId_").delete();
        this.reset();
        if(this.components.admin.display){
          this.components.admin.vue?.parentCallback("reset");
          this.components.admin.display = false;
        }
        if(this.components.main.display){
          this.components.main.vue?.parentCallback("reset");
          this.components.main.display = false;
        }
        this.$store.commit("setUser",{
            "userId":"",
            "userName":"",
            "administrator":false,
        });
        this.components.login.display = true;
        comm.WaringMessege(this,this.text.messege.invalidSession,null,true);
        setTimeout(()=>{
          this.reset();
          this.initApiCon();
        },3000)
      },
      setUserInfo(){
        this.userData = this.$store.state.user;
            this.components.login.display = false;
            this.username = this.userData.userName;
            this.disUsermenu = false;
            if(this.userData.administrator){
              this.components.admin.display = true;
              setTimeout(this.showAdminPage,1);
            }else{
              this.components.main.display = true;
              setTimeout(this.showMainPage,1);
            }
            if(this.userData.lastLogin){
              comm.SnackbarMessege(this,`${this.text.messege.lastLogin}:${comm.formatDate(new Date(this.userData.lastLogin),'mm/dd HH:MM:SS')}`,'#2196F3',true,10000);
            }
      },
      async logout(){
        if(this.api && this.api.connection && this.api.apiRequest){
          const result = await this.api.apiRequest.request.desSession();
          if(result.data){
            if(this.components.admin.display){
              this.components.admin.vue?.parentCallback("reset");
              this.components.admin.display = false;
            }
            if(this.components.main.display){
              this.components.main.vue?.parentCallback("reset");
              this.components.main.display = false;
            }
            this.$store.commit("setUser",{
                "userId":"",
                "userName":"",
                "administrator":false,
            });
            this.components.login.display = true;
            this.reset();
            this.initApiCon();
          }else{
            comm.ApiErrorMessege(this,{"httpStatus":1,"code":1});
          }
        }else{
            comm.ApiErrorMessege(this,{"httpStatus":1,"code":1});
        }
      },
      showAdminPage(){
        this.components.admin.vue = this.$refs.refAdmin as vueAdd;
        this.components.admin.vue?.parentCallback('pageShow');
      },
      showMainPage(){
        this.components.main.vue = this.$refs.refMain as vueAdd;
        this.components.main.vue?.parentCallback('pageShow');
      },
      chgPassword(){
        const passchgComp = this.$refs.refPassChg as passwordChgComponent;
        passchgComp.chgPassword();
      },
      setTotp(){
        const passchgComp = this.$refs.refPassChg as passwordChgComponent;
        passchgComp.setTotp();
      },
      digTotpSetClose(){
        this.password = "",
        this.digTotpSet = false;
      },
      async checkAdressConf(confCode:string){
        console.log(`checkAdressConf(${confCode})`)
        if(this.api && this.api.connection && this.api.apiRequest){
          const verify = await this.api.apiRequest.request.addressConf(confCode);
          console.log(verify);
          if(verify.data.flag){
              this.digConfedAdress = true;
            }
        }
        /*
        await apiCall.userAdress.conf(confCode).then(apiResponse=>{
          if(apiResponse.statusCode === 200 && apiResponse.data){
            const apiData = apiResponse.data;
            if(apiData.flag){
              this.digConfedAdress = true;
            }
          }
        })
        */
      },
      async submitReport(){
        this.requiredChkAlert = false;
        for(const [k,v] of Object.entries(this.qList)){
            v._error = false;
            v._errorMessege = "";
          if(v.required && !v.value){
            this.requiredChkAlert = true;
            v._error = true;
            v._errorMessege = this.text.required;
          }
        }
        if(this.requiredChkAlert){
          return false;
        }
        for(const [k,v] of Object.entries(this.qList)){
            delete v._error;
            delete v._errorMessege;
        }
        this.disBtnReportSubmit = true;
        comm.LoadingOverlay(this,true,true);
        const url = new URL(document.URL);
        if(this.api && this.api.connection && this.api.apiRequest){
            const au = url.searchParams.has("au")?url.searchParams.get("au"):null;
            const response = await this.api.apiRequest.request.postEcReport(this.reportId,this.qList,au||undefined);
            comm.LoadingOverlay(this,false,true);
            if(response.statusCode === 200){
              //this.ecReport = false;
              this.ecMessege.flag = true;
              this.ecMessege.text = this.text.messege.reportSubmitted;
              this.ecMessege.url = `${window.location.origin}${window.location.pathname}`;
            }else{
              comm.ApiErrorMessege(this,comm.unknowError,true);
            }
        }
/*
        await apiCall.ecReport(this.reportId,this.answerProxy,this.qList).then(apiResponse=>{
          comm.LoadingOverlay(this,false,true);
          if(apiResponse.statusCode === 200){
            this.ecReport = false;
            this.ecMessege.flag = true;
            this.ecMessege.text = this.text.messege.reportSubmitted;
            this.ecMessege.url = `${window.location.origin}${window.location.pathname}`;
          }else if(apiResponse.error){
            comm.ApiErrorMessege(this,apiResponse.error,true);
          }else{
            comm.ApiErrorMessege(this,comm.unknowError,true);
          }
        });
        */
      },
    }
  });
</script>
<style>
.hoverPointer:hover{
  cursor: pointer;
}
</style>
